import { Grid } from "@mui/material";
import ProductGroupEditDialog from "pages/product_grouping/menu/ProductGroupEditDialog";
import ProductGroupMenu from "pages/product_grouping/menu/productGroupMenu";
import ProductGroupItem from "pages/product_grouping/ProductGroupItem";
import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteProductGroupThunk,
  getProductGroupsThunk,
  productGroupSelector,
} from "store/reducers/product/productGroupsSlice";
import ProductGroupEditImageDialog from "./menu/ProductGroupEditImageDialog";

const ProductGroupingList = () => {
  const dispatch = useDispatch();
  const drawerOpen = useSelector((state) => state.menu.drawerOpen);
  const groups = useSelector(productGroupSelector.selectAll);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [contextMenu, setContextMenu] = React.useState(null);
  const [currentItem, setCurrentItem] = React.useState(null);
  const handleClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setCurrentItem(item);
  };
  const handleContextMenu = (event, item) => {
    event.preventDefault();
    setCurrentItem(item);
    setContextMenu(
      contextMenu === null
        ? {
            mouseX: event.clientX - 2,
            mouseY: event.clientY - 4,
          }
        : null
    );
  };
  const handleClose = () => {
    setAnchorEl(null);
    setContextMenu(null);
  };

  useEffect(() => {
    dispatch(getProductGroupsThunk());
  }, []);

  const [openGroupUpdate, setOpenGroupUpdate] = React.useState(false);
  const handleGroupClose = () => {
    setOpenGroupUpdate(false);
  };
  const deleteGroup = (id) => {
    dispatch(deleteProductGroupThunk(id));
  };
  const [openGroupImageUpdate, setOpenGroupImageUpdate] = React.useState(false);
  const handleGroupImageClose = () => {
    setOpenGroupImageUpdate(false);
  };
  return (
    <Grid container spacing={1} marginTop={1}>
      {groups.map((group) => (
        <Grid item xl={3} lg={drawerOpen ? 4 : 3} md={6} xs={12} key={group.id}>
          <ProductGroupItem
            group={group}
            handleClick={handleClick}
            handleContextMenu={handleContextMenu}
          />
        </Grid>
      ))}
      <ProductGroupMenu
        context={true}
        group={currentItem}
        anchorEl={anchorEl}
        handleClose={handleClose}
        contextMenu={contextMenu}
        setOpenGroupUpdate={setOpenGroupUpdate}
        deleteGroup={deleteGroup}
      />
      <ProductGroupMenu
        context={false}
        group={currentItem}
        anchorEl={anchorEl}
        handleClose={handleClose}
        contextMenu={contextMenu}
        setOpenGroupUpdate={setOpenGroupUpdate}
        setOpenGroupImageUpdate={setOpenGroupImageUpdate}
        deleteGroup={deleteGroup}
      />
      {(currentItem && openGroupUpdate)&&(
        <ProductGroupEditDialog
          open={openGroupUpdate}
          handleClose={handleGroupClose}
          group={currentItem}
        />
      )}
      {currentItem && openGroupImageUpdate && (
        <ProductGroupEditImageDialog
          open={openGroupImageUpdate}
          handleClose={handleGroupImageClose}
          group={currentItem}
        />
      )}
    </Grid>
  );
};

export default ProductGroupingList;
